/**
 * @fileoverview Animals theme - match animal emojis.
 */

import { ThemeOptions } from '../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../Labels.js';

export class BooksTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'books',
            'Books',
            allLabels.books,
            { numPairs: 6, ...options }
        );
    }
}
